import $ from 'jquery';
import 'slick-carousel';

export class Slider {

    constructor() {

        this.$imageSlider = this._getImageSlider();
        this.$HeroSlider = this._getHeroSlider();
        this.$simpleSlider = this._getSimpleSlider();

        // image slider config
        this.ImgSliderConfig = {
            infinite: true,
            centerMode: false,
            slidesToShow: 1.5,
            slidesToScroll: 1,
            adaptiveHeight: false,
            arrows: true,
            lazyLoad: 'ondemand',
        };

        // hero slider config
        this.HeroSliderConfig = {
            infinite: true,
            slidesToShow: 1,
            arrows: true,
            lazyLoad: 'ondemand'
        }

        // simple slider config
        this.SimpleSliderConfig = {
            infinite: true,
            slidesToShow: 1,
            arrows: true,
            // lazyLoad: 'ondemand',
            adaptiveHeight: true
        }

        this.init();
    }

    _getImageSlider() {
        return $('.slider--image');
    }

    _getHeroSlider() {
        return $('.slider--hero');
    }

    _getSimpleSlider() {
        return $('.slider--simple');
    }

    // init method
    init() {

        // image slider init
        if (!this.$imageSlider.hasClass('slick-initialized')) {
            this.$imageSlider.slick(this.ImgSliderConfig);
        }

        // hero slider init
        if (!this.$HeroSlider.hasClass('slick-initialized')) {
            this.$HeroSlider.slick(this.HeroSliderConfig);
        }

        // artilce slider init
        if (!this.$simpleSlider.hasClass('slick-initialized')) {
            this.$simpleSlider.slick(this.SimpleSliderConfig);
        }

    }

    // update sliders
    update() {

        this.$imageSlider = this._getImageSlider();
        this.$HeroSlider = this._getHeroSlider();
        this.$SimpleSlider = this._getSimpleSlider();

        // image slider update
        if (this.$imageSlider.length) {
            if (this.$imageSlider.hasClass('slick-initialized')) {
                this.$imageSlider.slick('refresh');
            }
            else {
                this.init();
            }
        }

        // hero slider update
        if (this.$HeroSlider.length) {
            if (this.$HeroSlider.hasClass('slick-initialized')) {
                // this.$HeroSlider.slick('refresh');
            }
            else {
                this.init();
            }
        }

        // article slider update
        if (this.$SimpleSlider.length) {
            if (this.$SimpleSlider.hasClass('slick-initialized')) {
                // this.$HeroSlider.slick('refresh');
            }
            else {
                this.init();
            }
        }

    }

}
